import { Box, Button } from '@mui/material';
import React, { useRef } from 'react';
import { authState } from 'store/auth/auth.slice';
import { useAppSelector } from 'store/hooks';

interface IProfilePictureUploader {
   updateUserPictureState: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const ProfilePictureUploader: React.FC<IProfilePictureUploader> = ({ updateUserPictureState }) => {
   const { loggedUserData } = useAppSelector(authState);
   const fileInputRef = useRef<HTMLInputElement>(null);

   if (loggedUserData === null) {
      return null;
   }

   const handleFileSelect = () => {
      fileInputRef.current?.click();
   };

   return (
      <Box
         sx={{
            position: 'absolute',
            mt: 6,
            ml: 6,
         }}
      >
         {/* Hidden file input */}
         <input
            type='file'
            accept='image/*'
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={updateUserPictureState}
         />

         <Button
            sx={{
               minWidth: '32px',
               minHeight: '32px',
               borderRadius: '100%',
               backgroundColor: '#FFFFFF',
               width: 4,
               height: 4,
               display: 'flex',
               alignItems: 'center',
               justifyContent: 'center',
               '&:hover': {
                  backgroundColor: '#FFFFFF',
               },
            }}
            onClick={handleFileSelect}
         >
            <svg width={16} height={16} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
               <mask
                  id='a'
                  style={{
                     maskType: 'alpha',
                  }}
                  maskUnits='userSpaceOnUse'
                  x={0}
                  y={0}
                  width={16}
                  height={16}
               >
                  <path fill='#D9D9D9' d='M0 0h16v16H0z' />
               </mask>
               <g mask='url(#a)'>
                  <path
                     d='M2 14.001q-.55 0-.942-.391a1.28 1.28 0 0 1-.392-.942v-8q0-.55.392-.942.391-.39.941-.391h2.1l.834-.9A1.34 1.34 0 0 1 5.916 2h2.75q.283 0 .475.192a.65.65 0 0 1 .192.475.65.65 0 0 1-.192.475.65.65 0 0 1-.475.192h-2.75L4.699 4.668H2v8h10.667V7.335q0-.285.192-.475a.65.65 0 0 1 .475-.192q.283 0 .475.192a.65.65 0 0 1 .191.475v5.333q0 .55-.391.942a1.28 1.28 0 0 1-.942.391zM12.665 3.335h-.667a.65.65 0 0 1-.475-.192.65.65 0 0 1-.191-.475q0-.283.191-.475A.65.65 0 0 1 12 2.001h.667v-.666q0-.285.192-.475a.65.65 0 0 1 .475-.192q.283 0 .475.192a.65.65 0 0 1 .191.475V2h.667q.283 0 .475.192a.65.65 0 0 1 .192.475.65.65 0 0 1-.192.475.65.65 0 0 1-.475.192H14V4a.65.65 0 0 1-.191.475.65.65 0 0 1-.475.192.65.65 0 0 1-.475-.192.65.65 0 0 1-.192-.475zm-5.333 8.333q1.25 0 2.125-.875a2.9 2.9 0 0 0 .875-2.125q0-1.25-.875-2.125a2.9 2.9 0 0 0-2.125-.875q-1.25 0-2.125.875a2.9 2.9 0 0 0-.875 2.125q0 1.25.875 2.125a2.9 2.9 0 0 0 2.125.875m0-1.333a1.6 1.6 0 0 1-1.184-.484 1.6 1.6 0 0 1-.483-1.183q0-.7.483-1.183A1.6 1.6 0 0 1 7.333 7q.699 0 1.183.484.483.483.483 1.183T8.516 9.85a1.6 1.6 0 0 1-1.183.484'
                     fill='#F55D66'
                  />
               </g>
            </svg>
         </Button>
      </Box>
   );
};

export default ProfilePictureUploader;
